// TODO: Consider about enabling style differences based on media queries through some additional property for this component
import React from 'react';
import PropTypes from 'prop-types';

import useTooltip from '../../hooks/useTooltip';
import styles from '../../styles/views/components/Button.module.scss';

const Button = ({
  id,
  value,
  variant,
  color,
  icon,
  isDisabled,
  onClick,
  extraStyles,
  extraClass,
  wrapperExtraStyles,
  name,
  tooltip,
  iconAsComponent,
  iconAsComponentEnd,
}) => {
  useTooltip();

  return (
    <div className={styles.wrapper} style={wrapperExtraStyles} data-tip={tooltip} id={id}>
      <button
        className={`${styles[variant]} ${styles[color]} ${extraClass}`}
        disabled={isDisabled}
        onClick={onClick}
        style={extraStyles}
        name={name}
      >
        {icon && <i className={`${styles.icon} ${styles[icon]}`} />}
        {iconAsComponent}
        <span>{value}</span>
        {iconAsComponentEnd}
      </button>
    </div>
  );
};

Button.defaultProps = {
  icon: '',
  isDisabled: false,
  extraStyles: null,
  wrapperExtraStyles: null,
  extraClass: '',
  tooltip: '',
  name: '',
  iconAsComponent: null,
  iconAsComponentEnd: null,
  id: '',
};

Button.propTypes = {
  value: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['link', 'primary', 'secondary']).isRequired,
  color: PropTypes.oneOf(['gold', 'red', 'violet', 'orange', 'green', 'blue', 'sky-blue']).isRequired,
  icon: PropTypes.string,
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  extraStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  wrapperExtraStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  extraClass: PropTypes.string,
  tooltip: PropTypes.string,
  iconAsComponent: PropTypes.node,
  iconAsComponentEnd: PropTypes.node,
  id: PropTypes.string,
};

export default Button;
